import logo from "./logo.svg";
import "./CSS/App.css";
import { Box, Button } from "@chakra-ui/react";
import Landing from "./UI/Pages/Landing";
import LandingV2 from "./v2/Landing/LandingV2";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import Main from "./UI/Pages/Main";
import { MainV2 } from "./v2/Main/MainV2";
import { Onboarding } from "./UI/Pages/Onboarding";
import { Steps } from "./UI/Pages/Steps";
import { Payments } from "./UI/Pages/Payments";
import { SignInHandle } from "./UI/Pages/SignInHandle";
import usePersistedId from "./Helper/usePersistedId";
import { DocumentSign } from "./UI/Security/Documents/documentSign";
import { GuestVerify } from "./UI/Security/Documents/guestVerify";
import { Deposit } from "./UI/Security/Documents/deposit";
import { GuidesPage } from "./v2/Main/Pages/GuidesPage";
import { ServicesPage } from "./v2/Main/Pages/ServicesPage";
import { UpsellPage } from "./v2/Main/Pages/UpsellPage";
import { LookupLanding } from "./v2/Lookup/LookupLanding";
import { PropertyLanding } from "./v2/Property/PropertyLanding";

function RedirectWithId() {
  const id = usePersistedId();

  if (id) {
    console.log(id);

    return <Navigate to={`/${id}/landing`} replace />;
  }

  // Handle the case where id is not present
  // This could happen if the user navigates to a route that doesn't match your patterns
  // Redirect to a default or 404 page
  return <Navigate to="/404" replace />;
}

function App() {
  return (
    <Routes>
      <Route path="*" element={<RedirectWithId />} />
      <Route exact path="/:id/landing" element={<Landing />} />
      <Route exact path="/:id/landing/:propertyId" element={<Landing />} />
      
      {/* New v2 route for the /go format */}
      <Route exact path="/go" element={<LandingV2 />} />

      {/* Direct upsell purchase page. Same bootstrap as /go, but skips
          the landing/onboarding UI when security steps are already done
          and opens the target upsell immediately. */}
      <Route exact path="/upsell" element={<UpsellPage />} />

      {/* QR-driven lookup flow (Part 1). Public — no Cognito session
          required. Part 2 (/lookup/:ownerId/find) ships separately. */}
      <Route exact path="/lookup/:ownerId" element={<LookupLanding />} />

      {/* Permanent per-property link for manual accounts (no PMS, no
          bookings). Opens the main screen in property-only mode. */}
      <Route exact path="/p/:roomId" element={<PropertyLanding />} />

      <Route exact path="/auth" element={<SignInHandle />} />
      <Route exact path="/onboarding" element={<Onboarding />} />
      <Route exact path="/main" element={<Main />} />
      <Route exact path="/main-v2" element={<MainV2 />} />
      <Route exact path="/guides" element={<GuidesPage />} />
      <Route exact path="/services" element={<ServicesPage />} />
      <Route exact path="/steps" element={<Steps />} />
      <Route exact path="/payments" element={<Payments />} />
      <Route exact path="/documents" element={<DocumentSign />} />
      <Route exact path="/id_verify" element={<GuestVerify />} />
      <Route exact path="/deposit" element={<Deposit />} />

      <Route path="/404" element={<div>Page not found</div>} />
    </Routes>
  );
}

export default App;

// export default withAuthenticator(App);
